import { Box } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import { FormikInput } from 'components/Formik';
import { useSaveUserDetail } from 'hooks/profile/useSaveUserDetail';

import { initialProfileFormData, profileValidationSchema } from './schema';

interface IProfileFormProps {
  formData: typeof initialProfileFormData;
}

const ProfileForm: React.FC<IProfileFormProps> = ({ formData = initialProfileFormData }) => {
  const { t } = useTranslation(['profile', 'common']);
  const navigate = useNavigate();

  const { status: saveUserStatus, mutate: saveUserMutate } = useSaveUserDetail();

  const handleFormSubmit = async (values: typeof initialProfileFormData) => {
    const postData = {
      firstName: values.firstName,
      lastName: values.lastName,
      phone: values.phone,
    };
    saveUserMutate(postData);
  };

  return (
    <Box maxWidth="100%" mt="12" width={{ base: '90vw', sm: '400px' }}>
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={profileValidationSchema}
        onSubmit={handleFormSubmit}
      >
        {() => (
          <Form noValidate>
            <FormikInput type="text" name="firstName" label={t('common:firstName')} />
            <FormikInput type="text" name="lastName" label={t('common:lastName')} />
            <FormikInput
              type="text"
              name="email"
              label={t('common:emailAddress')}
              formControlProps={{ isDisabled: true }}
            />
            <FormikInput type="text" name="phone" label={t('common:phoneNumber')} />
            <Button type="submit" colorScheme="secondary" isLoading={saveUserStatus === 'loading'}>
              {t('common:saveChanges')}
            </Button>
            <Button
              _hover={{ bg: 'gray.100' }}
              _active={{ bg: 'gray.200' }}
              ml="5"
              onClick={() => navigate(-1)}
              variant="ghost"
            >
              {t('common:cancel')}
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ProfileForm;
